import React, { useCallback, useState } from "react";
import { Button } from "components/bootstrap";
import RetrievalArchiveModal from "data-lake/data-lake-overview/actions/RetrievalArchiveModal";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useRetrieval from "data-lake/preview/hooks/useRetrieval";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
const RetrieveLogsAction = ({ fieldsOperator, fieldFilters, stream, timerange }) => {
  const [showRetrievalModal, setShowRetrievalModal] = useState(false);
  const sendTelemetry = useSendTelemetry("log-view-widget");
  const { onRetrieveMessages } = useRetrieval();
  const { selectedDataLake } = useSelectedDataLake();
  const onToggleModal = useCallback(() => {
    if (!showRetrievalModal) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].RETRIEVE_LOGS_BUTTON_CLICK, {
        app_pathname: "/data-storage/preview",
        event_details: {
          data_lake_storage_type: selectedDataLake.storageType
        }
      });
    }
    setShowRetrievalModal((cur) => !cur);
  }, [selectedDataLake.storageType, selectedDataLake.type, sendTelemetry, showRetrievalModal]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { onClick: onToggleModal, title: "Retrieve all logs", bsSize: "xsmall" }, "Retrieve all results"), showRetrievalModal && /* @__PURE__ */ React.createElement(
    RetrievalArchiveModal,
    {
      archiveStreamId: stream,
      onToggleModal,
      calculateEstimatedSize: selectedDataLake.type === INTERNAL_DATA_LAKE_TYPE,
      onRetrieveMessages,
      defaultTimeRange: timerange,
      defaultFieldOperator: fieldsOperator,
      defaultFieldFilters: fieldFilters
    }
  ));
};
export default RetrieveLogsAction;
